<div
  class="ne-font"
  style="font-family: {fontFamily}; font-weight: {fontWeight};"
  data-test-font-button="{fontFamily}"
  on:click="{onSelect}">
  <Radio
    {id}
    value="{fontFamily}"
    text="{getDisplayName(fontFamily)}"
    checked="{isSelected}"
    choose="{(event) => {event.preventDefault()}}"
  />
</div>

<style>
  .ne-font {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 42px;
    margin: 4px 0px;
    border: 1px solid #d1d1d1;
    border-radius: 4px;
    cursor: pointer;
    line-height: 16px;

    transition: border-color 0.5s;
  }

  .ne-font:hover {
    border-color: #cd2033;
  }
</style>

<script>
  import { getDisplayName } from '../lib/font-utils';
  import Radio from './Radio.html';

  export let fontFamily;
  export let fontWeight;
  export let isSelected;
  export let onSelect;

  $: id = `${fontFamily}-radio`;
  $: checkboxClassName = isSelected ? "ne-font-checkbox ne-font-checkbox-selected" : "ne-font-checkbox";
</script>
